import * as React from 'react';

import { getServicesAggregation } from '../../../../../../ServicesAggregation/context';
import { CheckoutCardExtrasProvider } from '../../../../../../CardExtra';
import { LoyaltyOrderCard } from '@widgets/order/loyalty-order-card';

const Loyalty: React.FC = () => {
	const { userInfo, refetchUser } = getServicesAggregation();

	return (
		<CheckoutCardExtrasProvider userInfo={userInfo} updateUser={refetchUser}>
			<LoyaltyOrderCard variant="aggregator" />
		</CheckoutCardExtrasProvider>
	);
};

export default Loyalty;
